<template>
  <div class="project-nf">
    <div class="project-nf__header">
      <img src="/statics/ocean_logo.png" alt="">
    </div>
    <div class="project-nf__bg" />
    <div class="project-nf__wrapper">
      <div class="project-nf__info">
        <i class="el-icon-more" />
        <p>
          <b>
            {{ $t("Your account is being configured.") }}
          </b>
        </p>
        <p>
          {{ $t("After the configuration is complete you will have access to your projects.") }}
        </p>
        <p>{{ $t("Please check again later.") }}</p>
      </div>
    </div>
    <div class="project-nf__footer">
      <img src="/statics/logo.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectNotFound'
};
</script>

<style lang="scss">
  .project-nf {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 30px;
    text-align: center;
    background:
      linear-gradient(188.87deg, #28a7a4 8.73%, #1d7bb9 100.79%),
      radial-gradient(
        30.04% 30.05% at 47.86% 84.12%,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0) 100%
      );

    &__header {
      img {
        width: 230px;
      }
    }

    &__bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("/statics/ocean_icon.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    &__info {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 450px;
      padding: 25px 40px;
      margin-bottom: 20vh;
      font-size: 14px;
      background: #fff;
      border-radius: 10px;

      i {
        font-size: 80px;
        color: $brilliantAzure;
      }
    }
  }
</style>
